import {UserInterfaceConfigurationService} from "../../services/configuration/UserInterfaceConfigurationService";
import {TranslationsLanguage} from "../config/TranslationsLanguage";
import {Observable, ReplaySubject, Scheduler} from "rxjs";
import {translate} from "angular";

const ConfigKey = "selected-language";

export class LanguageService {

    public static readonly id = "languageService";

    private readonly current$ = new ReplaySubject<TranslationsLanguage>(1);

    /** @ngInject */
    public constructor(private readonly userInterfaceConfigurationService: UserInterfaceConfigurationService,
                       private readonly $translate: translate.ITranslateService) {
    }

    /*
     * As we don't select a language before this point, we should theoretically avoid any flashing of the UI caused by
     * the async loading of a user's settings
     */
    public init() {
        const defaultLanguage = this.defaultLanguage();
        this.$translate.use(defaultLanguage);
        this.current$.next(defaultLanguage);

        this.userInterfaceConfigurationService
            .load<TranslationsLanguage>(ConfigKey)
            .then((language) => {
                if (language == null) {
                    this.$translate.use(defaultLanguage);
                    this.current$.next(defaultLanguage);
                } else if (language in TranslationsLanguage) { // Check we still support the language
                    this.$translate.use(language);
                    this.current$.next(language);
                } else {
                    this.$translate.use(TranslationsLanguage.English);
                    this.current$.next(TranslationsLanguage.English);
                }
            });
    }

    private defaultLanguage(): TranslationsLanguage {
        if ("language" in navigator) {
            const language = navigator.language;
            if (language.toLocaleLowerCase().startsWith("zh")) {
                return TranslationsLanguage.Chinese;
            } else {
                return TranslationsLanguage.English;
            }
        } else {
            return TranslationsLanguage.English;
        }
    }

    public use(language: TranslationsLanguage) {
        this.$translate.use(language);
        this.userInterfaceConfigurationService.save(ConfigKey, language);
        this.current$.next(language);
    }

    public current(): Observable<TranslationsLanguage> {
        return this.current$.observeOn(Scheduler.async);
    }
}
